import React from "react";
import styled from "styled-components";
import * as Icon from "react-feather";

import { H1, P } from "../../atoms/Texts";
import { useNavigate, useParams } from "react-router";
import { PrimaryButton } from "../../atoms/Buttons";
import { Link } from "react-router-dom";

const OrganizationPageHeroStyle = styled.div`
  background: #f8f6fe;
`;

const OrganizationPageHero = ({
  title,
  description,
  action,
  className,
  back,
  goBackText,
}) => {
  let history = useNavigate();
  const { id } = useParams();

  return (
    <OrganizationPageHeroStyle
      className={`pt-16 pb-12 container ${className ? className : ""}`}
    >
      <div className="flex justify-between">
        <div>
          <H1 fontSize="26px" color="#22202D" className="">
            {title}
          </H1>
          {description && <P color="#1E202A">{description}</P>}
        </div>
        <Link to={`/dashboard/organization/${id}/programs/add`}>
          <PrimaryButton>Add Service</PrimaryButton>
        </Link>
      </div>
      {back && (
        <div
          className="flex items-center cursor-pointer"
          style={{
            width: "fit-content",
          }}
          onClick={() => history.goBack()}
        >
          <Icon.ChevronLeft size={14} color="#7D7B96" className="mr-2" />
          <P color="#1E202A" fontSize="14px" smallSize="14px">
            {goBackText}
          </P>
        </div>
      )}
    </OrganizationPageHeroStyle>
  );
};

export default OrganizationPageHero;
